import { Button, Buttons, Header, Input, Modal, Skeleton, TimeAgo } from 'components';

import useDetails from './useDetails';

export const Details = () => {
  const {
    apiKey,
    setIsDeactivateVisible,
    isDeactivateVisible,
    onDeactivate,
    deactivateString,
    setDeactivateString,
  } = useDetails();

  return (
    <>
      <div className="card sm:mb-[60px] mb-[24px] sm:p-5 sm:pb-8 p-4  !bg-transparent !bg-gradient-to-b from-[#000_20.37%] to-[#000_79.34%] text-white rounded-[20px] !border-[#1F1F1F]">
        <div className="flex flex-wrap whitespace-nowrap items-center ">
          <div className="flex flex-1 items-center uppercase">
            <Skeleton.Loader isDarkTheme className="w-60 h-7">
              <div className="text-base font-medium">API Key</div>
            </Skeleton.Loader>
          </div>
          <div className="text-sm text-[#B2B3B8]">
            <Skeleton.Loader isDarkTheme className="w-20 h-7">
              Created <TimeAgo date={apiKey?.createdAt || ''} className="text-sm" />
            </Skeleton.Loader>
          </div>
        </div>
        <Skeleton.Loader isDarkTheme containerClassName="flex-1 flex mt-3">
          <Input
            className="mt-2 w-full !bg-[#060606] h-[48px] rounded-[25px] border border-solid !border-[#1F1F1F]"
            isDarkTheme
            isCopyOnly
            classNames={{ input: 'text-white', copyBtn: 'bg-transparent' }}
            value={apiKey?.key || ''}
            copyValue={apiKey?.key || ''}
          />
        </Skeleton.Loader>
      </div>
      <Header className="text-white text-2xl leading-[130%] sm:items-center items-start">
        Basic Details
      </Header>
      <div className="card sm:mb-[60px] mb-[40px] sm:p-5 p-4  !bg-transparent bg-gradient-to-b from-[#000_20.37%] to-[#000_79.34%] text-white rounded-[20px] !border-[#1F1F1F]">
        <div className="uppercase text-white text-base font-medium">
          <Skeleton.Loader isDarkTheme className="w-20 h-7">
            Name
          </Skeleton.Loader>
        </div>
        <Skeleton.Loader isDarkTheme containerClassName="flex flex-1 mt-3">
          <Input
            isCopyOnly
            isDarkTheme
            className="text-md flex-1 max-w-full text-ellipsis whitespace-nowrap overflow-hidden font-medium mt-2 !border-[#1f1f1f] !bg-[#060606] rounded-3xl h-[48px] !border-solid w-full"
            value={apiKey?.name || ''}
            copyValue={apiKey?.name || ''}
            classNames={{ copyBtn: 'bg-transparent' }}
          />
        </Skeleton.Loader>
      </div>
      <Header className="text-2xl text-white font-normal sm:items-center items-start">
        Deactivate API Key
      </Header>
      <div className="card flex flex-col sm:flex-row sm:items-center items-start gap-4 sm:p-6 p-4 !bg-transparent bg-gradient-to-b from-[#000_20.37%] to-[#000_79.34%] text-white rounded-[20px] !border-[#1F1F1F]">
        <div className="flex-1">
          <Skeleton.Loader isDarkTheme className="w-full h-8">
            Any applications using this project&apos;s keys will no longer be able to access the
            Timegraph API. This can not be undone.
          </Skeleton.Loader>
        </div>
        <Skeleton.Loader isDarkTheme className="h-10 w-48">
          <Button onClick={() => setIsDeactivateVisible(true)} variant="darkThemeOutlined">
            Deactivate API Key
          </Button>
        </Skeleton.Loader>
      </div>
      <Modal
        isDarkTheme
        isOpen={isDeactivateVisible}
        setIsOpen={setIsDeactivateVisible}
        className="max-w-md"
        classNames={{ content: 'items-start' }}
      >
        <div className="mb-3 text-center">
          <h5 className="text-left">Deactivate API Key</h5>
          <div className="mt-2 text-sm text-neutral-500">
            Type &apos;deactivate&apos; below to confirm:
          </div>
        </div>
        <form
          className="w-full"
          onSubmit={(e) => {
            e.preventDefault();
            onDeactivate();
          }}
        >
          <Input
            className="mb-4 w-ful rounded-[20px] !border-[#1F1F1F] !bg-transparent bg-gradient-to-b from-[#000_20.37%] to-[#000_79.34%] h-[48px]"
            classNames={{ input: 'text-white' }}
            value={deactivateString}
            onChange={setDeactivateString}
          />
          <Buttons className="w-full">
            <Button
              variant="darkThemeOutlined"
              className="h-12"
              onClick={() => {
                setIsDeactivateVisible(false);
              }}
            >
              Cancel
            </Button>
            <Button
              isDisabled={deactivateString !== 'deactivate'}
              isSubmit
              variant="darkThemeFilled"
              className="h-12"
            >
              Confirm
            </Button>
          </Buttons>
        </form>
      </Modal>
    </>
  );
};
